import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Button } from "antd";
import moment from "moment";

import "dayjs/locale/ko";
import { Editor } from "@toast-ui/react-editor";
import Swal from "sweetalert2";

import commentApi from "../../apis/Comment.api";
import longlifeApi from "../../apis/Longlife.api";
import { toastAlert } from "../AlertComponent";
import CommentImageSlideGroup from "../channel/comment/CommentImageSlideGroup";

import ReplyComponent from "./ReplyComponent";

const CommentComponent = ({
	comment,
	getAdminCommentList,
	setReadLoading,
	totalCount,
	currentPageNumber,
	setCurrentPageNumber,
}) => {
	// const pageSize = 5;
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	// const isLoading = useSelector((state) => state.common.loading);
	const user = useSelector((state) => state.auth.user);

	const editorRef = useRef(null);
	const toolbarItems = [["link"]];

	const [addReplyShow, setAddReplyShow] = useState(false);
	const [replyListShow, setReplyListShow] = useState(true);

	const [replyLoading, setReplyLoading] = useState(false);

	const [replyObj, setReplyObj] = useState({
		content: "",
		is_secret: false,
	});

	const textStyle = {
		letterSpacing: "-0.05px",
		color: "#212529",
		wordBreak: "break-word",
		whiteSpace: "pre-wrap",
	};

	/**
	 * 카테고리명 번역
	 * @param category
	 * @returns {string}
	 */
	const translateCategory = (category) => {
		if (category === "ingredient") {
			return "성분별";
		} else if (category === "function") {
			return "고민별";
		} else if (category === "combination") {
			return "조합별";
		} else if (category === "recommend_nutrients") {
			return "문의글";
		} else if (category === "cooperate") {
			return "공동구매";
		} else if (category === "health_magazine") {
			return "건강 매거진";
		} else if (category === "mission") {
			return "클래스";
		} else if (category === "event") {
			return "이벤트";
		} else {
			return "소통";
		}
	};

	/**
	 * 댓글이 달려있는 페이지 열기
	 */
	const openCommentPage = () => {
		const category = comment?.category_type;
		const categoryId = comment?.category_id?.length
			? comment?.category_id
			: comment?.board_id;

		let url = `/together/channel`;

		if (category === "community") {
			// url += `/${category}/${categoryId}?id=${
			// 	user?.role === "level_1" || user?.role === "super_admin"
			// 		? user?.influencer_id
			// 		: user?.role
			// }&whereShow=edit`;
			url = `https://www.dangyoung.com/together/@${comment?.influencer_link}/community/${categoryId}`;
		} else if (category === "recommend_nutrients") {
			// url = "https://dangyoung.onelink.me/hLYF/1blf4q6g";
			url = `https://www.dangyoung.com/together/@${comment?.influencer_link}/recommend/${categoryId}`;
		} else if (category === "cooperate") {
			url = `https://www.dangyoung.com/together/@${comment?.influencer_link}/groupBuying/${categoryId}`;
		} else if (category === "health_magazine") {
			url = `https://www.dangyoung.com/together/@${comment?.influencer_link}/magazine/${categoryId}`;
		} else if (category === "mission") {
			url = `https://www.dangyoung.com/together/@${comment?.influencer_link}/mission/${categoryId}`;
		} else {
			url = `https://www.dangyoung.com/together/@${comment?.influencer_link}/${category}/${categoryId}`;
			// url += `/${category}s/detail/${categoryId}?id=${
			// 	user?.role === "level_1" || user?.role === "super_admin"
			// 		? user?.influencer_id
			// 		: user?.role
			// }`;
		}
		// if (category !== "community") {
		// 	url += `/${category}s/detail/${categoryId}?id=${
		// 		user?.role === "level_1" || user?.role === "super_admin"
		// 			? user?.influencer_id
		// 			: user?.role
		// 	}`;
		// } else {
		// 	url += `/${category}/${categoryId}?id=${
		// 		user?.role === "level_1" || user?.role === "super_admin"
		// 			? user?.influencer_id
		// 			: user?.role
		// 	}&whereShow=edit`;
		// }
		if (comment?.is_show) {
			if (!replyLoading) {
				window.open(url, "_blank");
			}
		} else {
			toastAlert("비공개 게시글은 확인 할 수 없습니다.");
		}
	};

	/**
	 * 답글 작성 취소
	 */
	const cancelAddReply = () => {
		let contentByTag = editorRef.current?.getInstance().getHTML();
		if (replyObj?.content?.length || contentByTag?.length > 0) {
			Swal.fire({
				customClass: "alert-custom",
				text: `작성 중인 답글이 있습니다. 취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setReplyObj({
						content: "",
						is_secret: false,
					});
					setAddReplyShow(false);
				}
			});
		} else {
			setReplyObj({
				content: "",
				is_secret: false,
			});
			setAddReplyShow(false);
		}
	};

	/**
	 * 답글 작성 완료
	 */
	const submitAddReply = async () => {
		let contentByTag = editorRef.current?.getInstance().getHTML();
		if (contentByTag?.length > 0) {
			setReplyLoading(true);
			setReadLoading(true);

			let res = null;
			if (comment?.category_type === "mission") {
				const param = {
					mission_id: comment?.board_id,
					verification_id: comment?.id,
					content: contentByTag ?? replyObj?.content,
					created_by: user?.id,
					is_app: false,
					is_influencer: true,
				};
				res = await longlifeApi.registerReplyForApp(param);
			} else {
				const param = {
					comment_id: comment?.id,
					content: contentByTag ?? replyObj?.content,
					is_secret: replyObj?.is_secret,
					created_by: user?.id,
					is_influencer: true,
					influencer_id: reduxChannel?.user_id ?? user?.id,
				};
				res = await commentApi.createReply(param);
			}
			if (res.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "성공적으로 작성이 완료되었습니다.",
					confirmButtonText: "확인",
				}).then(() => {
					if (
						currentPageNumber > 0 &&
						totalCount - 1 <= (currentPageNumber - 1) * 5
					) {
						setCurrentPageNumber(currentPageNumber - 1);
						setReplyObj({
							content: "",
							is_secret: false,
						});
						setAddReplyShow(false);
					} else {
						getAdminCommentList();
						setReplyObj({
							content: "",
							is_secret: false,
						});
						setAddReplyShow(false);
					}
				});
			} else {
				getAdminCommentList();
				setReadLoading(false);
			}
			setReplyLoading(false);
		}
	};

	/**
	 * 댓글 삭제
	 * @returns {Promise<void>}
	 */
	const handleDeleteComment = async () => {
		setReplyLoading(true);
		setReadLoading(true);
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 댓글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let res = null;
				if (comment?.category_type === "mission") {
					const param = {
						id: comment?.id,
						userId: comment?.created_by,
						influencerId: user?.id,
						isApp: false,
					};
					res = await longlifeApi.deleteVerificationByAdmin(param);
				} else {
					const param = {
						commentId: comment?.id,
						userId: user?.id,
					};
					res = await commentApi.adminDeleteComment(param);
				}
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "정상적으로 삭제가 완료되었습니다.",
						confirmButtonText: "확인",
					}).then(() => {
						// getAdminCommentList();
						if (
							currentPageNumber > 0 &&
							totalCount - 1 <= (currentPageNumber - 1) * 5
						) {
							setCurrentPageNumber(currentPageNumber - 1);
						} else {
							getAdminCommentList();
						}
					});
				} else {
					setReadLoading(false);
				}
			} else {
				setReplyLoading(false);
				setReadLoading(false);
			}
		});
		setReplyLoading(false);
	};

	return (
		<>
			<div className={`comment-manage-each`}>
				<div className={`comment-by-user`}>
					<img
						src={`${
							comment?.is_influencer
								? `${process.env.REACT_APP_S3_HOST}/image/together/profile_${comment?.created_by}.${user?.profile_img_type}`
								: comment?.is_app
								? comment?.profile_img_type && Number(comment?.profile_url) > 0
									? `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/profile/${comment.created_by}-${comment.profile_url}.${comment.profile_img_type}`
									: `/assets/images/channel/basic.png`
								: comment?.profile_img_type
								? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${comment?.created_by}.${comment?.profile_img_type}`
								: `/assets/images/channel/basic.png`
						}`}
						alt={`댓글 프로필 이미지`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							// currentTarget.style.display = "none";
							currentTarget.src = `/assets/images/channel/basic.png`;
						}}
						className={`comment-img`}
					/>
					<div className={`comment-div-each`}>
						<div className={`comment-div-each-row`}>
							{/*<p className={`gray`}>*/}
							{/*    {comment?.phone}*/}
							{/*</p>*/}
							{comment?.is_influencer ? (
								<p
									className={`gray ${
										user?.id === comment?.created_by ? "influencer-id" : ""
									}`}
								>
									{comment?.created_by_name}
								</p>
							) : (
								<p className={`gray`}>
									{comment?.created_by_name
										? comment?.created_by_name
										: comment?.phone}
								</p>
							)}
							<p className={`gray`}>ㆍ</p>
							<p className={`gray`}>
								{moment(moment(comment?.created_at), "YYYY.MM.DD").fromNow()}
							</p>
							{!!comment?.is_secret && (
								<>
									<p className={`gray`}>ㆍ</p>
									<p className={`secret`}>비밀댓글</p>
									<img
										src={`/assets/images/channel/secret.png`}
										alt={`비밀댓글`}
										style={{
											width: "13px",
											height: "13px",
										}}
									/>
								</>
							)}
						</div>
						<div
							className={`comment-div-each-row`}
							style={{
								flexDirection: "column",
								alignItems: "flex-start",
							}}
						>
							{!!comment?.imageList?.length && (
								<CommentImageSlideGroup
									imageList={comment?.imageList}
									type={"comment"}
								/>
							)}
							{comment.category_type === "recommend_nutrients" && (
								<>
									<p style={textStyle}>{comment?.birthday}</p>
									<p style={textStyle}>{comment?.gender}</p>
									<p style={textStyle}>{comment?.disease}</p>
									<p style={textStyle}>{comment?.taking_nutrients}</p>
								</>
							)}
							<p style={textStyle}>{comment?.content}</p>
						</div>
						<div className={`comment-div-each-row`}>
							<button onClick={handleDeleteComment} disabled={replyLoading}>
								삭제
							</button>
							<button
								onClick={() => {
									setReplyObj({
										...replyObj,
										is_secret: comment?.is_secret,
									});
									setAddReplyShow(!addReplyShow);
								}}
								disabled={replyLoading}
							>
								답글달기
							</button>
							<button
								onClick={() => setReplyListShow(!replyListShow)}
								style={{
									display: "flex",
									alignItems: "center",
								}}
								disabled={!comment?.replyDTOList?.length || replyLoading}
							>
								답글 {comment?.replyDTOList?.length}개
								<img
									src={`/assets/images/report/${
										replyListShow ? "up" : "down"
									}.png`}
									alt={`드롭다운`}
									style={{
										width: "0.9em",
										height: "0.9em",
										marginLeft: "3px",
									}}
								/>
							</button>
						</div>
					</div>
				</div>

				{replyListShow && (
					<>
						{/* 답글 리스트 */}
						{comment?.replyDTOList?.map((reply, idx) => (
							<div
								className={`comment-by-user comment-is-reply`}
								key={`reply-comment-${idx}`}
							>
								<ReplyComponent
									comment={comment}
									reply={reply}
									addReplyShow={addReplyShow}
									setAddReplyShow={setAddReplyShow}
									getAdminCommentList={getAdminCommentList}
									replyLoading={replyLoading}
									setReplyLoading={setReplyLoading}
									replyObj={replyObj}
									setReplyObj={setReplyObj}
									setReadLoading={setReadLoading}
								/>
							</div>
						))}
					</>
				)}

				{/* 답글 달기 */}
				{addReplyShow && (
					<div className={`comment-by-user comment-is-reply`}>
						<img
							src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${user?.id}.${user?.profile_img_type}`}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								// currentTarget.style.display = "none";
								currentTarget.src = `/assets/images/channel/basic.png`;
							}}
							alt={`채널 이미지`}
							className={`comment-img`}
						/>
						<div className={`comment-div-each`}>
							{/*<Input.TextArea*/}
							{/*	className={`comment-textarea`}*/}
							{/*	type={`text`}*/}
							{/*	placeholder={`답글 내용을 작성해주세요`}*/}
							{/*	value={replyObj.content}*/}
							{/*	onChange={(e) =>*/}
							{/*		setReplyObj({*/}
							{/*			...replyObj,*/}
							{/*			content: e.target?.value,*/}
							{/*		})*/}
							{/*	}*/}
							{/*/>*/}
							<Editor
								ref={editorRef}
								initialEditType={"wysiwyg"} // wysiwyg & markdown
								initialValue={""} // 글 수정 시 사용
								// initialValue={contentTitle.content || ""} // 글 수정 시 사용
								previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
								hideModeSwitch={true}
								theme={""} // '' & 'dark'
								usageStatistics={false}
								toolbarItems={toolbarItems}
								useCommandShortcut={true}
								// plugins={[colorSyntax]}
								language="ko-KR"
								height={"15em"}
								placeholder={"답글 내용을 작성해주세요"}
							/>
							<div className={`comment-textarea-footer edit-reply-component`}>
								<Button
									className={`reply-with-secret-edit`}
									onClick={() =>
										setReplyObj({
											...replyObj,
											is_secret: !replyObj.is_secret,
										})
									}
									disabled={replyLoading}
								>
									<img
										src={`/assets/images/login/check${
											replyObj.is_secret ? "-active" : ""
										}.png`}
										alt={`비밀글`}
										style={{
											height: "auto",
											width: "1.1em",
										}}
									/>
									{/*비밀글로 작성하기*/}
									비밀글
								</Button>
								<div className={`reply-edit-button-group`}>
									<Button onClick={cancelAddReply} disabled={replyLoading}>
										취소
									</Button>
									<Button
										// disabled={!replyObj?.content?.length || replyLoading}
										disabled={replyLoading}
										onClick={submitAddReply}
									>
										완료
									</Button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>

			<div className={`comment-link`} onClick={openCommentPage}>
				<div className={`link-guide`}>
					<div className={`link-category`}>
						{translateCategory(comment?.category_type)}
					</div>
					{comment?.category_type !== "recommend_nutrients" &&
						comment?.category_type !== "cooperate" && (
							<img
								src={`/assets/images/channel/right-arrow.png`}
								alt={`화살표`}
								style={{
									height: "1.5em",
									width: "1.5em",
								}}
							/>
						)}

					{comment?.category_name && (
						<div className={`link-sub`}>{comment?.category_name}</div>
					)}
				</div>
				{comment?.link_title && (
					<p className={`link-title`}>{comment?.link_title}</p>
				)}
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5em",
					}}
				>
					<img
						src={`/assets/images/report/link.png`}
						alt={`링크 이동`}
						style={{
							width: "1.4em",
							height: "1.4em",
							cursor: "pointer",
						}}
					/>
					{!comment?.is_show && (
						<span style={{ color: "#868e96" }}>비공개글</span>
					)}
				</div>
			</div>
		</>
	);
};
export default CommentComponent;
